<template>
  <div class="painting_box">
    <div class="nav_head">
      <div class="nav_box">
        <i class="return_icon van-icon-arrow-left" @click="goBack"></i>
        <span>機甲塗裝庫</span>
        <!-- <div class="nav_btn">
          <i class="paint_rule" @click="detailClick(581195)"></i>
        </div> -->
      </div>
    </div>
    <div class="nav_list">
      <div
        class="nav_item"
        v-for="(item, index) in navArr"
        :key="index"
        @click="getTab(item.id)"
      >
        <span :class="currentNav == item.id ? 'nav_on' : ''">{{
          item.nav
        }}</span>
        <i class="tab_icon" v-show="currentNav == item.id"></i>
      </div>
    </div>
    <div class="list_box">
      <van-list
        v-show="paintArr.length > 0"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="painting_list" v-if="paintArr.length > 0">
          <paintingCard
            v-for="(item, index) in paintArr"
            :key="index"
            :cardData="item"
          ></paintingCard>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import get from '@/api/get';
import paintingCard from '../../../../paintingCard';
export default {
  components: { paintingCard },
  data() {
    return {
      ganlanMAPaintSubejct: '', //涂装库话题Id
      page: 1,
      currentNav: 3, //默认
      loading: false,
      finished: false,
      navArr: [
        {
          nav: '智能推薦',
          id: 3
        },
        {
          nav: '人氣塗裝',
          id: 2
        },
        {
          nav: '最新發佈',
          id: 4
        }
      ],
      paintArr: []
    };
  },
  computed: {},
  watch: {
    '$store.state.token'(token) {
      if (token != '') {
        this.resolveHander && this.resolveHander();
      }
    }
  },
  methods: {
    detailClick(id) {
      let _path = '../topicPage/?topicId=' + id + '&isGame=true';
      this.$router.push({
        path: _path
      });
    },
    getTab(id) {
      this.currentNav = id;
      this.clearPage();
      this.getPaintingList();
    },
    clearPage() {
      this.page = 1;
      this.paintArr = [];
      this.finished = false; //防止切换tab后，onload失效
    },
    getgetPaintingListApi() {
      let params = {
        queryType: 3,
        partitionId: this.ganlanMAPaintSubejct,
        sortType: this.currentNav,
        pageNo: this.page,
        pageSize: 10
      };
      get.getTopics(params).then((resChild) => {
        this.paintArr = this.paintArr.concat(resChild.data.data.list);
        this.loading = false;
        if (resChild.data.data.list.length == 0) {
          this.finished = true;
        }
      });
    },
    getPaintingList() {
      if (this.ganlanMAPaintSubejct !== '') {
        this.getgetPaintingListApi();
      } else {
        get.getGlGamePaintingId().then((res) => {
          if (res.data.code == 0) {
            this.ganlanMAPaintSubejct = res.data.data.ganlanMAPaintSubejct;
            this.getgetPaintingListApi();
          }
        });
      }
    },
    goBack() {
      this.$emit('getTabView', true);
      this.$router.back();
    },
    onLoad() {
      this.page++;
      this.getPaintingList();
    }
  },
  async created() {
    this.$emit('getTabView', false);
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    this.getPaintingList();
  },
  mounted() {},
  activated() {
    this.$emit('getTabView', false);
  }
};
</script>
<style lang='scss' >
.ipad.gl .painting_box {
  .publicAction_item .card_good_box {
    left: 0.86rem;
  }
  .card {
    .publishedWrap {
      margin: 0;
      li {
        box-sizing: border-box;
        border-radius: 0.2rem;
        .userInfo {
          width: auto;
        }
      }
    }
  }
  .card_publishedContent_imgboxVertical {
    width: 5.43rem;
    height: 3.06rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang='scss' scoped>
.ipad.gl .painting_box {
  width: 12.5rem;
  .nav_head {
    height: 1.2rem;
    .nav_box {
      width: 100%;
      margin-top: 0.1rem;
      padding: 0 0.3rem;
      box-sizing: border-box;
    }
  }
  .nav_list {
    width: 100%;
  }
  .list_box {
    width: 100%;
    top: 2.1rem;
    .painting_list {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .card {
      width: 5.99rem;
      box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
      margin-bottom: 0.2rem;
    }
  }
}
.painting_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .nav_head {
    width: 100%;
    height: 1.78rem;
    display: flex;
    justify-content: center;
    background: linear-gradient(180deg, #151f26 0%, #23323d 100%);
    .nav_box {
      margin-top: 0.8rem;
      width: 6.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .return_icon{
        position: absolute;
        left: 0;
      }
      span {
        font-weight: 400;
        color: #ffffff;
        font-size: 0.34rem;
      }
      .nav_btn {
        display: flex;
        align-items: center;
        .paint_rule {
          width: 0.39rem;
          height: 0.39rem;
          background: url('~@/assets/img/gl/gameIntro/paint-rule.png');
          background-size: 100% 100%;
          margin-right: 0.22rem;
        }
        .search_btn {
          width: 0.42rem;
          height: 0.4rem;
          background: url('~@/assets/img/gl/gameIntro/search-icon-1.png');
          background-size: 100% 100%;
        }
      }
    }
  }
  .nav_list {
    width: 6.88rem;
    display: flex;
    margin-top: 0.3rem;
    .nav_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 0.63rem;
      cursor: pointer;
      span {
        font-weight: 400;
        color: #2b2b2b;
        font-size: 0.3rem;
      }
      .nav_on {
        font-weight: bold;
        color: #23323d;
      }
      .tab_icon {
        width: 0;
        height: 0;
        border-width: 0.1rem;
        border-style: solid;
        border-color: #23323d transparent transparent transparent;
      }
    }
  }
  .list_box {
    height: calc(100vh - 2.6rem);
    position: absolute;
    top: 2.6rem;
    overflow-y: auto;
  }
  .painting_list {
    width: 6.88rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .card {
      width: 100%;
    }
  }
}
</style>